const LOCAL_DOMIN = 'https://api.qdj8.cn'
const DEV_DOMIN = 'https://sitapi.qdj8.cn'
const SIT_DOMIN = 'https://sitapi.qdj8.cn'
const STAGING_DOMIN = 'https://stgapi.qdj8.cn'
const PROD_DOMIN = 'http://api.qdj8.cn'
const PROD_DOMIN_QINIU_XIAOZHAOBAO = 'https://api.qdj8.cn'
const PROD_DOMIN_QINIU_QDJ8 = 'https://api.qdj8.cn'
const PROD_DOMIN_QINIU_WS_QDJ8 = 'https://ws.qdj8.cn'

const LOCAL_MOBILE_DOMIN_URL = 'https://mobile.qdj8.cn'
const PROD_MOBILE_DOMIN_URL = 'https://mobile.qdj8.cn'

var currentDomin = LOCAL_DOMIN;
var currentDominWs = LOCAL_DOMIN;
var mobileUrlDomin = LOCAL_MOBILE_DOMIN_URL;
if (process.env.CK_ENV === 'production') {
    currentDomin = PROD_DOMIN;
    mobileUrlDomin = PROD_MOBILE_DOMIN_URL;
} else if (process.env.CK_ENV === 'production_qiniu_xiaozhaobao') {
    currentDomin = PROD_DOMIN_QINIU_XIAOZHAOBAO;
    currentDominWs = PROD_DOMIN_QINIU_WS_QDJ8;
    mobileUrlDomin = PROD_MOBILE_DOMIN_URL;
} else if (process.env.CK_ENV === 'production_qiniu_qdj8') {
    currentDomin = PROD_DOMIN_QINIU_QDJ8;
    currentDominWs = PROD_DOMIN_QINIU_WS_QDJ8;
    mobileUrlDomin = PROD_MOBILE_DOMIN_URL;
} else if (process.env.CK_ENV === 'sit') {
    currentDomin = SIT_DOMIN
} else if (process.env.CK_ENV === 'staging') {
    currentDomin = STAGING_DOMIN;
    currentDominWs = STAGING_DOMIN;
} else if (process.env.CK_ENV === 'local') {
    currentDomin = LOCAL_DOMIN
}


const APIV1 = currentDomin + '/api/v1'
const APIV2 = currentDomin + '/api/v2'


module.exports = {
    YQL: [],
    CORS: [SIT_DOMIN, PROD_DOMIN, LOCAL_DOMIN, DEV_DOMIN, STAGING_DOMIN, PROD_DOMIN_QINIU_XIAOZHAOBAO, PROD_DOMIN_QINIU_QDJ8,PROD_DOMIN_QINIU_WS_QDJ8],
    api_domin: currentDomin,
    mobile_url_domin: mobileUrlDomin,
    api: {

        //登录
        userLogin: `${APIV1}/users/login`,
        thirdPlatformLogin: `${APIV1}/users/oauth/login`,
        thirdPlatformLoginUrl: `${APIV1}/users/oauth/login-url`,
        //登出
        userLogout: `${APIV1}/users/logout`,
        //登录信息
        loginUserInfo: `${APIV1}/users/current`,
        wxLoginUserInfo: `${APIV1}/core/users/login-info`,
        wxLoginQrcode: `${APIV1}/core/others/wxmp/have-params-qrcode`,
        

        //官网
        articles: `${APIV1}/ops/website/article`,
        article: `${APIV1}/ops/website/article/:id`,
        categorys: `${APIV1}/ops/website/category`,
        category: `${APIV1}/ops/website/category/:id`,
        threenum: `${APIV1}/ops/website/three-num`,
        livestreamConfig: `${APIV1}/core/sys/config/enable-zhibo`,

        //增值服务
        vasAllGroupByType: `${APIV1}/ops/vas/all-vas-group-by-type`,
        vasVaild: `${APIV1}/ops/vas/:vasId/valid`,
        //增值服务-充值包
        vasTopups: `${APIV1}/ops/vas/vas-topup`,
        vasTopup: `${APIV1}/ops/vas/vas-topup/:vasId`,
        vasTopupPricing: `${APIV1}/ops/vas/vas-topup/:vasId/pricing/:pricingId`,
        vasTopupPricingEnable: `${APIV1}/ops/vas/vas-topup/:vasId/pricing/:pricingId/enable`,
        vasTopupPricingDisable: `${APIV1}/ops/vas/vas-topup/:vasId/pricing/:pricingId/disable`,
        vasTopupPricingShow: `${APIV1}/ops/vas/vas-topup/:vasId/pricing/:pricingId/show`,
        vasTopupPricingHide: `${APIV1}/ops/vas/vas-topup/:vasId/pricing/:pricingId/hide`,
        //增值服务-实体商品
        vasProducts: `${APIV1}/ops/vas/vas-product`,
        vasProduct: `${APIV1}/ops/vas/vas-product/:vasId`,
        vasProductPricing: `${APIV1}/ops/vas/vas-product/:vasId/pricing/:pricingId`,
        vasProductPricingEnable: `${APIV1}/ops/vas/vas-product/:vasId/pricing/:pricingId/enable`,
        vasProductPricingDisable: `${APIV1}/ops/vas/vas-product/:vasId/pricing/:pricingId/disable`,
        vasProductPricingShow: `${APIV1}/ops/vas/vas-product/:vasId/pricing/:pricingId/show`,
        vasProductPricingHide: `${APIV1}/ops/vas/vas-product/:vasId/pricing/:pricingId/hide`,
        //增值服务-订阅服务
        vasSvcs: `${APIV1}/ops/vas/vas-svc`,
        vasSvc: `${APIV1}/ops/vas/vas-svc/:vasId`,
        vasSvcValidity: `${APIV1}/ops/vas/vas-svc/validity`,
        vasSvcPricing: `${APIV1}/ops/vas/vas-svc/:vasId/pricing/:pricingId`,
        vasSvcPricingEnable: `${APIV1}/ops/vas/vas-svc/:vasId/pricing/:pricingId/enable`,
        vasSvcPricingDisable: `${APIV1}/ops/vas/vas-svc/:vasId/pricing/:pricingId/disable`,
        vasSvcPricingShow: `${APIV1}/ops/vas/vas-svc/:vasId/pricing/:pricingId/show`,
        vasSvcPricingHide: `${APIV1}/ops/vas/vas-svc/:vasId/pricing/:pricingId/hide`,
        vasSvcsAdmin: `${APIV1}/ops/vas/vas-svc/purchased/admin`,
        vasSvcAdmin: `${APIV1}/ops/vas/vas-svc/extend-validity/admin`,
        //增值服务-会员
        vasMemberships: `${APIV1}/ops/vas/vas-membership`,
        vasMembership: `${APIV1}/ops/vas/vas-membership/:vasId`,
        vasMembershipBenefitSave: `${APIV1}/ops/vas/vas-membership/:vasId/benefit`,
        vasMembershipPricing: `${APIV1}/ops/vas/vas-membership/:vasId/pricing/:pricingId`,
        vasMembershipPricingEnable: `${APIV1}/ops/vas/vas-membership/:vasId/pricing/:pricingId/enable`,
        vasMembershipPricingDisable: `${APIV1}/ops/vas/vas-membership/:vasId/pricing/:pricingId/disable`,
        vasMembershipPricingShow: `${APIV1}/ops/vas/vas-membership/:vasId/pricing/:pricingId/show`,
        vasMembershipPricingHide: `${APIV1}/ops/vas/vas-membership/:vasId/pricing/:pricingId/hide`,
        vasMembershipComputeUpgrade: `${APIV1}/ops/vas/vas-membership/compute-upgrade-member`,
        vasMembershipCreateUpgrade: `${APIV1}/ops/vas/vas-membership/create-upgrade-member`,
        //查询用户购买的所有订阅服务
        usersPurchased: `${APIV1}/ops/vas/vas-svc/purchased`,
        //通知
        broadcasts: `${APIV1}/ops/broadcast`,
        broadcast: `${APIV1}/ops/broadcast/:bId`,
        broadcastPush: `${APIV1}/ops/broadcast/:bId/push`,
        broadcastRecent: `${APIV1}/ops/broadcast/recent`,
        //邀请函模板
        invitationTpls: `${APIV1}/ops/invttmpls`,
        invitationTpl: `${APIV1}/ops/invttmpls/:id`,
        //邀请函背景音乐
        invitationBgms: `${APIV1}/ops/invtbgmusic`,
        invitationBgm: `${APIV1}/ops/invtbgmusic/:id`,
        //反馈
        feedbacks: `${APIV1}/ops/feedback`,
        feedback: `${APIV1}/ops/feedback/:id`,
        evtFeedbacks: `${APIV1}/core/events/feedback`,
        evtFeedback: `${APIV1}/core/events/feedback/:id`,
        evtFeedbackShow: `${APIV1}/core/events/:eventId/show-feedback`,
        // 短信渠道
        smsfilters: `${APIV1}/ops/smsfilters`,
        smsfilter: `${APIV1}/ops/smsfilters/:filterId`,
        smsfilterActive: `${APIV1}/ops/smsfilters/:filterId/active`,
        mateChannel: `${APIV1}/ops/smsfilters/channel`,

        //主办方抽奖
        drawpool: `${APIV1}/onsite/drawpool`,
        winners: `${APIV1}/onsite/drawpool/winners`,
        drawpoolitem: `${APIV1}/onsite/drawpoolitem`,
        draw: `${APIV1}/onsite/drawpool/draw`,
        winnerItem: `${APIV1}/onsite/drawpool/items/:id/winners`,
        predraw: `${APIV1}/onsite/drawpool/predraw`,
        winnersByPage: `${APIV1}/onsite/drawpool/winnersByPage`,
        toReceived: `${APIV1}/onsite/drawpool/toReceived/:winnerId`,
        drawpoolExport: `${APIV1}/onsite/drawpool/winners/export`,
        drawpoolLogo: `${APIV1}/onsite/drawpool/logo`,
        //参与人摇奖
        rollpools: `${APIV1}/onsite/rollpool`,
        adminRollpools: `${APIV1}/onsite/admin/indep-roll`,
        rollpoolCreate: `${APIV1}/onsite/rollpool/create`,
        rollpool: `${APIV1}/onsite/rollpool/:poolId`,
        rollpoolRecover: `${APIV1}/onsite/rollpool/:poolId/recover`,
        rollpoolItems: `${APIV1}/onsite/rollpool/:poolId/item`,
        scan: `${APIV1}/onsite/rollpool/:poolId/scan`,
        roll: `${APIV1}/onsite/rollpool/:poolId/roll`,
        winnersPoolItems: `${APIV1}/onsite/rollpool/:poolId/findWinnersPoolItems`,
        receivedItems: `${APIV1}/onsite/rollpool/:poolId/receivedItems`,
        attendeeWinners: `${APIV1}/onsite/rollpool/:poolId/findWinners`,
        pushRollWinner: `${APIV1}/onsite/rollpool/:poolId/item/:itemId/pushRollWinner`,
        rollpoolExport: `${APIV1}/onsite/rollpool/:poolId/winners/export`,
        attendeeWinners2: `${APIV1}/onsite/rollpool/:poolId/winners`,
        rollpoolCountWinners: `${APIV1}/onsite/rollpool/:poolId/count-winners`,
        rollpoolLogo: `${APIV1}/onsite/rollpool/:poolId/logo`,
        //黑白名单
        rollpoolBwLists: `${APIV1}/onsite/rollpool/:poolId/bw-list`,
        rollpoolBwList: `${APIV1}/onsite/rollpool/:poolId/bw-list/:bwId`,
        rollpoolOrder: `${APIV1}/onsite/rollpool/:poolId/item/:itemId/paid`,

        drawpoolBwLists: `${APIV1}/onsite/drawpool/:poolId/bw-list`,
        drawpoolBwList: `${APIV1}/onsite/drawpool/:poolId/bw-list/:bwId`,
        //弹幕
        barrages: `${APIV1}/onsite/barrage`,
        barrage: `${APIV1}/onsite/barrage/:id`,
        barrageTop: `${APIV1}/onsite/barrage/:id/top`,
        barrageAudit: `${APIV1}/onsite/barrage/audit`,
        barrageConfigs: `${APIV1}/onsite/barrage/config`,
        barrageConfig: `${APIV1}/onsite/barrage/config/:configId`,
        barrageOpenTime: `${APIV1}/onsite/barrage/config/:configId/open-time`,
        barrageTitle: `${APIV1}/onsite/barrage/find-id-title`,
        barrageSpanTime: `${APIV1}/onsite/barrage/span-by-time`,
        barrageUploadImg: `${APIV1}/onsite/barrage/config/:configId/background-img`,
        barrageExtract: `${APIV1}/onsite/barrage/extract`,
        barragePush: `${APIV1}/onsite/barrage/:id/puah`,
        //红包雨
        luckyMoneys: `${APIV1}/onsite/luckymoney`,
        luckyMoney: `${APIV1}/onsite/luckymoney/:id`,
        preGrab: `${APIV1}/onsite/luckymoney/:id/pre-grab`,
        grab: `${APIV1}/onsite/luckymoney/:id/grab`,
        selfDetails: `${APIV1}/onsite/luckymoney/:id/self-details`,
        winnerDetails: `${APIV1}/onsite/luckymoney/:id/winner-details`,
        luckyMoneyEnd: `${APIV1}/onsite/luckymoney/:id/end`,
        luckyMoneyWinnerExp: `${APIV1}/onsite/luckymoney/:id/winners/export`,

        //打赏
        rewards: `${APIV1}/onsite/reward`,
        reward: `${APIV1}/onsite/reward/:id`,
        rewardSimple: `${APIV1}/onsite/reward/:id/simple`,
        rewardAmounts: `${APIV1}/onsite/reward/:rewardId/amount`,
        rewardAmount: `${APIV1}/onsite/reward/:rewardId/amount/:id`,
        rewardTargets: `${APIV1}/onsite/reward/:rewardId/target`,
        rewardTarget: `${APIV1}/onsite/reward/:rewardId/target/:id`,
        rewardDetails: `${APIV1}/onsite/reward/:rewardId/detail`,
        rewardDetailsOwner: `${APIV1}/onsite/reward/:rewardId/detail/owner`,
        rewardRanking: `${APIV1}/onsite/reward/:rewardId/detail/ranking-list`,
        rewardTargetRanking: `${APIV1}/onsite/reward/:rewardId/detail/target-ranking-list`,
        rewardDetailsExp: `${APIV1}/onsite/reward/:rewardId/export`,
        rewardDetailsPush: `${APIV1}/onsite/reward/:rewardId/detail/:detailId/push`,
        rewardDetail: `${APIV1}/onsite/reward/:rewardId/detail/:detailId`,
        rewardRecover: `${APIV1}/onsite/reward/:id/recover`,

        //会销
        markets: `${APIV1}/onsite/market`,
        market: `${APIV1}/onsite/market/:id`,
        marketSimple: `${APIV1}/onsite/market/:id/simple`,
        marketRecover: `${APIV1}/onsite/market/:id/recover`,
        marketGoods: `${APIV1}/onsite/market/:marketId/goods`,
        marketGood: `${APIV1}/onsite/market/:marketId/goods/:id`,
        marketPurchases: `${APIV1}/onsite/market/:marketId/purchase`,
        marketPurchasesOwner: `${APIV1}/onsite/market/:marketId/purchase/owner`,
        marketRankLists: `${APIV1}/onsite/market/:marketId/purchase/rank-list`,
        marketExport: `${APIV1}/onsite/market/:marketId/export`,
        marketPurchasePush: `${APIV1}/onsite/market/:marketId/purchase/:purchaseId/push`,
        marketPurchase: `${APIV1}/onsite/market/:marketId/purchase/:purchaseId`,

        //竞猜
        guesss: `${APIV1}/onsite/guess`,
        guess: `${APIV1}/onsite/guess/:id`,
        guessRecover: `${APIV1}/onsite/guess/:id/recover`,
        guessTitle: `${APIV1}/onsite/guess/:guessId/title`,
        guessTitleBatch: `${APIV1}/onsite/guess/:guessId/title/batch`,
        guessGoods: `${APIV1}/onsite/guess/:guessId/goods`,
        guessGoodsBatch: `${APIV1}/onsite/guess/:guessId/goods/batch`,
        guessRankingList: `${APIV1}/onsite/guess/:guessId/player/ranking-list`,
        guessPlayer: `${APIV1}/onsite/guess/:guessId/player/default`,
        guessPlayers: `${APIV1}/onsite/guess/:guessId/player`,
        guessAnswerSubmit: `${APIV1}/onsite/guess/:guessId/player/:playerId/submit-one`,
        guessAnswerStart: `${APIV1}/onsite/guess/:guessId/player/:playerId/start`,
        guessAnswerEnd: `${APIV1}/onsite/guess/:guessId/player/:playerId/end`,
        guessAnswerResult: `${APIV1}/onsite/guess/:guessId/player/:playerId/answer-result`,
        guessReceived: `${APIV1}/onsite/guess/:guessId/player/:playerId/received`,
        guessFinish: `${APIV1}/onsite/guess/:id/finish`,
        guessSimple: `${APIV1}/onsite/guess/:id/simple`,
        guessExport: `${APIV1}/onsite/guess/:id/export`,
        guessPlayerDel: `${APIV1}/onsite/guess/:guessId/player/delete`,
        guessPaid: `${APIV1}/onsite/guess/:guessId/goods/:guessGoodsId/paid`,

        //签到墙
        signinwallConfig: `${APIV1}/onsite/signinwall/:eventId/by-event`,
        signinwall: `${APIV1}/onsite/signinwall/:id`,
        signinwallBmgs: `${APIV1}/onsite/customimg`,
        signinwallBmg: `${APIV1}/onsite/customimg/:id`,
        signinwallMessage: `${APIV1}/onsite/signinwall/:id/message`,
        signinwallMessageRecents: `${APIV1}/onsite/signinwall/message`,
        signinwallMessageRecent: `${APIV1}/onsite/signinwall/message/:id`,

        // 系统配置
        sysConfig: `${APIV1}/core/sys/config`,

        //日志回传
        bankLog: `${APIV1}/core/sys/logging/log`,
        // 用户例外配置
        exceptConfig: `${APIV1}/core/sys/exception/config`,
        exceptConfigParams: `${APIV1}/core/sys/exception/config/params`,
        exceptConfigOne: `${APIV1}/core/sys/exception/config/:id`,
        //文件上传
        uploadFile: `${APIV1}/core/sys/files`,
        uploadFileBase64: `${APIV1}/core/sys/files-by-base64`,
        downloadSpecialWordsFile: `${APIV1}/core/sys/files/getSpecialWordsFile`,
        //验证码
        smsCaptcha: `${APIV1}/core/sys/sms-captcha`,
        emailCaptcha: `${APIV1}/core/sys/email-captcha`,
        //系统枚举
        cmenums: `${APIV1}/core/sys/cmenums`,
        // client-version
        clientVersion:  `${APIV1}/core/sys/client/versions`,
        clientVersionOne:  `${APIV1}/core/sys/client/versions/:versionId`,
        //预匹配
        prematchMobile: `${APIV1}/core/sys/sms-captcha/prematch`,
        prematchEmail: `${APIV1}/core/sys/email-captcha/prematch`,
        //
        importOrExportTasks: `${APIV1}/core/sys/tasks`,
        attendeeCancel: `${APIV1}/core/sys/tasks/:taskId/cancel`,
        //消息通知
        informationPushes: `${APIV1}/core/sys/notifications/pushes`,
        notifyLogs: `${APIV1}/core/sys/notifications/logs`,
        notifyLogDetails: `${APIV1}/core/sys/notifications/log-details`,
        notifyLogDetailsRecipients: `${APIV1}/core/sys/notifications/log-details-recipients`,
        notifyLogPushTest: `${APIV1}/core/sys/notifications/push-test`,
        //信息记录
        notifyHistory: `${APIV1}/core/sys/msg/history`,
        notifyHistoryTemplate: `${APIV1}/core/sys/notifications/log-template`,
        refundTimer: `${APIV1}/core/sys/notifications/refund-timer-qcoin`,
        //app配置
        appIntroConfig: `${APIV1}/core/sys/config/app-cover`,

        //定制化
        cusWjw: `${APIV1}/core/custom-made/wjw/rule-config/:id`,
        cusWjws: `${APIV1}/core/custom-made/wjw/rule-config`,
        cusWjwByEvent: `${APIV1}/core/custom-made/wjw/rule-config/by-event`,
        cusWjwMake: `${APIV1}/core/events/:eventId/statistics/wjw-make`,
        cusWjwMakeReport: `${APIV1}/core/events/statistics/wjw-make-report`,
        cusWjwMakeTotalReport: `${APIV1}/core/events/statistics/wjw-make-total-report`,
        cusWjwMakeExp: `${APIV1}/core/events/:eventId/statistics/wjw-make/export`,

        //用户
        users: `${APIV1}/core/users`,
        userForget: `${APIV1}/core/users/forgetpasswd`,
        userRegister: `${APIV1}/core/users/register`,
        usersEnable: `${APIV1}/core/users/enable`,
        usersDisable: `${APIV1}/core/users/disable`,
        usersEnableToken: `${APIV1}/core/users/token/enabled`,
        userInfo: `${APIV1}/core/users/:userId/for-sign-up`,
        user: `${APIV1}/core/users/:id`,
        useVasBuy: `${APIV1}/core/users/:id/buy`,
        userEnable: `${APIV1}/core/users/:id/enable`,
        userDisable: `${APIV1}/core/users/:id/disable`,
        fetchFeeRate: `${APIV1}/core/users/:id/fee-rate`,
        updateFeeRate: `${APIV1}/core/users/:id/cash-withdraw-rate`,
        setSha1Id: `${APIV1}/core/users/default/set-sha1-id`,
        userEventStatistics: `${APIV1}/core/users/:userId/event-statistics`,
        //手续费率
        feeRate: `${APIV1}/core/users/default/fee-rate`,
        //查询用户填写的报名表单
        userFilldForm: `${APIV1}/core/users/default/filled-form`,
        userDefault: `${APIV1}/core/users/default`,
        //修改密码
        modifypasswd: `${APIV1}/core/users/modify-passwd`,
        modifypasswdByAdmin: `${APIV1}/core/users/:id/modifypasswdByAdmin/:newPwd`,
        userConsumeStatistics: `${APIV1}/core/users/consume-statistics`,
        //收货地址
        userAddresses: `${APIV1}/core/users/:userId/addresses`,
        userAddress: `${APIV1}/core/users/:userId/addresses/:addressId`,
        userAddressDefault: `${APIV1}/core/users/:userId/addresses/:addressId/default`,
        //角色
        roles: `${APIV1}/core/users/roles`,
        role: `${APIV1}/core/users/roles/:id`,
        //权限
        permissions: `${APIV1}/core/users/permissions`,
        permission: `${APIV1}/core/users/permissions/:id`,

        // 短信签名
        smssigns: `${APIV1}/core/users/default/smssigns`,
        smssignOne: `${APIV1}/core/users/:userId/smssigns/:signId`,
        sendLoading: `${APIV1}/core/events/send-msg/loading`,
        onlineUserCountStats: `${APIV1}//core/users/online-user/count-stats`,
        onlineUsers: `${APIV1}/core/users/online-user`,
        onlineUserTokens: `${APIV1}/core/users/online-user/:userId/tokens`,
        onlineUserKick: `${APIV1}/core/users/online-user/:userId/kick`,
        onlineUserKickExcludeOneself: `${APIV1}/core/users/online-user/default/kick-exclude-oneself`,
        onlineUserTokenKick: `${APIV1}/core/users/online-user/:userId/:token/kick`,

        //通讯录
        contacts: `${APIV1}/core/users/default/contacts`,
        contact: `${APIV1}/core/users/default/contacts/:id`,
        contactsAll: `${APIV1}/core/users/default/contacts-all`,
        contactImport: `${APIV1}/core/users/default/import`,
        contactExport: `${APIV1}/core/users/default/export`,
        importContactAvatar: `${APIV1}/core/users/contacts/batch-avatar`,
        //通讯录分组
        cttgroups: `${APIV1}/core/users/default/cttgroups`,
        cttgroup: `${APIV1}/core/users/default/cttgroups/:cttgroupId`,
        //通讯录分组成员
        cttgp: `${APIV1}/core/users/default/cttgroups/:cttgroupId/contacts`,
        //通讯录下载二维码
        contactExpQrcode: `${APIV1}/core/users/default/contacts/qrcode-export`,
        contactImportAttendees: `${APIV1}/core/users/contacts/import-attendees`,
        //流水导出
        transExport: `${APIV1}/core/users/default/cash-account/trans/export`,

        //提现
        withdraws: `${APIV1}/core/users/:userId/cash-account/withdraw`,
        withdraw: `${APIV1}/core/users/:userId/cash-account/withdraw/:withdrawId`,
        withdrawAutoEnable: `${APIV1}/core/users/:userId/cash-account/auto-withdraw-enable`,
        withdrawAutoDisable: `${APIV1}/core/users/:userId/cash-account/auto-withdraw-disable`,
        //
        withdrawableStats: `${APIV1}/core/users/cash-account/withdrawable`,
        withdrawableTotal: `${APIV1}/core/users/cash-account/withdrawable-total`,

        transSubjestStats: `${APIV1}/core/users/cash-account/trans-subject-stats`,
        //账户
        accountStats: `${APIV1}/core/users/:userId/account-stats`,
        userStats: `${APIV1}/core/users/:userId/user-stats`,
        //现金账户
        cashAccount: `${APIV1}/core/users/:userId/cash-account`,
        cashAccountTrans: `${APIV1}/core/users/:userId/cash-account/trans`,
        //签币账户
        qcoinAccount: `${APIV1}/core/users/:userId/qcoin-account`,
        qcoinAccountTrans: `${APIV1}/core/users/:userId/qcoin-account/trans`,
        qcoinTransfer: `${APIV1}/core/users/qcoin-account/transfer`,

        //发票列表
        invoices: `${APIV1}/core/users/:userId/invoices`,
        invoiceDeadline: `${APIV1}/core/users/:userId/invoices/deadline`,
        invoice: `${APIV1}/core/users/:userId/invoices/:invoiceId`,
        invoiceStats: `${APIV1}/core/users/:userId/invoices/stats`,
        invoiceBook: `${APIV1}/core/users/:userId/invoicebook`,
        attendeeInvoices: `${APIV1}/core/events/:eventId/attendees-invoice`,
        attendeeInvoice: `${APIV1}/core/events/:eventId/attendees-invoice/:id`,
        attendeeInvoiceExp: `${APIV1}/core/events/:eventId/attendees-invoice/export`,
        attendeeInvoiceInfo: `${APIV1}/core/users/default/attendee-invoice`,
        

        //ibeacon
        ibeacons: `${APIV1}/core/users/ibeacons`,
        ibeaconApply: `${APIV1}/core/users/ibeacons/apply`,
        ibeaconsAssign: `${APIV1}/core/users/ibeacons/assign`,
        ibeaconsConfigure: `${APIV1}/core/users/ibeacons/configure`,
        ibeaconsBatchConfigure: `${APIV1}/core/users/ibeacons/batch-configure`,
        userIbeacons: `${APIV1}/core/users/:userId/ibeacons`,
        ibeaconMaterialUpload: `${APIV1}/core/users/ibeacons/material`,

        //查询用户快递信息
        courier: `${APIV1}/core/users/:userId/couriers/:courierNo`,
        //发票审核
        invoiceverifys: `${APIV1}/core/users/invoices`,
        invoiceverify: `${APIV1}/core/users/invoices/:id`,
        invoicedeliver: `${APIV1}/core/users/invoices/:id/deliver`,
        invoiceupload: `${APIV1}/core/users/invoices/:id/upload`,
        invoiceOrderDesc: `${APIV1}/core/users/invoices/:id/order-desc`,
        invoiceUpdate: `${APIV1}/core/users/default/invoices/:id`,
        //银行卡
        bankcard: `${APIV1}/core/users/:userId/bankinfo`,
        //银行卡审核
        bankcardverifys: `${APIV1}/core/users/bankinfo`,
        bankcardApprove: `${APIV1}/core/users/bankinfo/approve`,
        bankcardDisapprove: `${APIV1}/core/users/bankinfo/disapprove`,
        //提现审核
        withdrawverifys: `${APIV1}/core/users/cash-account/withdraw`,
        withdrawverify: `${APIV1}/core/users/cash-account/withdraw/:id`,
        withdrawApprove: `${APIV1}/core/users/cash-account/withdraw/:id/approve`,
        withdrawDisapprove: `${APIV1}/core/users/cash-account/withdraw/:id/disapprove`,
        //退款审核
        refundverifys: `${APIV1}/core/users/refundverifys`,
        // 签名审核
        smssignverifys: `${APIV1}/core/users/smssigns`,
        smssignApprove: `${APIV1}/core/users/:userId/smssigns/:signId/approve`,
        smssignDisapprove: `${APIV1}/core/users/:userId/smssigns/:signId/disapprove`,

        //重置
        resetMobile: `${APIV1}/core/users/default/mobile/reset`,
        resetEmail: `${APIV1}/core/users/default/email/reset`,
        //是否关注签到家
        wxmpSubscribed: `${APIV1}/core/users/wxmp-subscribed`,
        //注销
        userRemove: `${APIV1}/core/users/remove`,

        userBuyVas: `${APIV1}/core/users/:userId/buy`,
        userQcoinTrans: `${APIV1}/core/users/:userId/qcoin-account/trans`,
        userCashTransTypes: `${APIV1}/core/users/:userId/cash-account/trans/types`,

        //子账号
        orgName: `${APIV1}/core/users/:userId/orgname/:orgName`,
        subAccounts: `${APIV1}/core/users/:userId/sub-accounts`,
        subAccount: `${APIV1}/core/users/:userId/sub-accounts/:id`,
        subAccountResetPwd: `${APIV1}/core/users/sub-accounts/:subUserId/reset-password`,
        subAccountResetLoginname: `${APIV1}/core/users/sub-accounts/:subUserId/reset-loginname`,
        subAccountEventsApplys: `${APIV1}/core/users/default/events-apply`,
        subAccountEventsApply: `${APIV1}/core/users/default/events-apply/:id`,
        subAccountExp: `${APIV1}/core/users/default/sub-account-exp`,
        subAccountGuest: `${APIV1}/core/users/default/sub-account-guest`,
        subAccountAudit: `${APIV1}/core/users/default/sub-account-audit`,
        subAccountAttendee: `${APIV1}/core/users/default/sub-account-edit-and-del`,

        // 营销渠道
        promotes: `${APIV1}/core/events/:eventId/promotes`,
        promoteOne: `${APIV1}/core/events/:eventId/promotes/:promoteId`,
        promoteOneLogo: `${APIV1}/core/events/:eventId/promotes/:promoteId/logo`,
        //高级会员判定
        isSMember: `${APIV1}/core/events/:eventId/is-member`,
        //分配管理
        allots: `${APIV1}/core/events/:eventId/allocate`,
        allotExfields: `${APIV1}/core/events/:eventId/allocate/exfields`,
        allotExfieldsPatch: `${APIV1}/core/events/:eventId/allocate/patch`,
        allotExfieldsTicket: `${APIV1}/core/events/:eventId/allocate/tickets/:ticketId`,
        allotImport: `${APIV1}/core/events/:eventId/allocate/import`,
        allotExport: `${APIV1}/core/events/:eventId/allocate/template`,
        //排号机
        numberMachine: `${APIV1}/core/events/:eventId/numbering-machine`,
        numberMachineReset: `${APIV1}/core/events/:eventId/numbering-machine/reset`,
        //分配字段
        allocateFields: `${APIV1}/core/events/:eventId/allocate-and-form/fields`,

        // 报表
        signUpReport: `${APIV1}/core/events/:eventId/report/sign-up`,
        signInReport: `${APIV1}/core/events/:eventId/report/sign-in`,
        exportReport: `${APIV1}/core/events/:eventId/report/export`,
        reportSpecial: `${APIV1}/core/events/:eventId/report/special`,

        //活动
        eventsDayRegistrationAndCheckinCountStats: `${APIV1}/core/events/:eventId/by-day-registration-and-checkin-count-stats`,
        events: `${APIV1}/core/events`,
        operationEvents: `${APIV1}/core/events/operation-count`,
        eventCreate: `${APIV1}/core/events?toPublish=:toPublish`,
        event: `${APIV1}/core/events/:id`,
        eventSimples: `${APIV1}/core/events/simple`,
        eventSimple: `${APIV1}/core/events/:id/simple`,
        eventRateLimit: `${APIV1}/core/events/:id/rate-limit`,
        eventRecover: `${APIV1}/core/events/:id/recover`,
        eventPublish: `${APIV1}/core/events/:id/publish`,
        eventNumCount: `${APIV1}/core/events/num-count`,
        eventExp: `${APIV1}/core/events/export`,
        //结业证书
        eventDiploma: `${APIV1}/core/events/:eventId/diploma`,
        eventDiplomaExp: `${APIV1}/core/sys/pdf/events/:eventId/diploma/pdf-export`,
        //活动复制
        eventDuplicate: `${APIV1}/core/events/:id/duplicate`,
        //活动基本信息和配置信息
        eventHeader: `${APIV1}/core/events/:id/header`,
        eventConfig: `${APIV1}/core/events/:id/config`,
        eventCzpromote: `${APIV1}/core/events/:id/czpromote`,
        eventCheckinCredit: `${APIV1}/core/events/:id/config/checkin-credit`,
        eventCheckinCredits: `${APIV1}/core/events/statistics/checkin-credit`,
        eventCheckinCreditsExp: `${APIV1}/core/events/statistics/checkin-credit/export`,
        //活动票务
        eventTicketings: `${APIV1}/core/events/:eventId/ticketing`,
        eventTicketing: `${APIV1}/core/events/:eventId/ticketing/:id`,
        eventTicketingEnable: `${APIV1}/core/events/:eventId/ticketing/:id/enable`,
        eventTicketingDisable: `${APIV1}/core/events/:eventId/ticketing/:id/disable`,
        //票务折扣
        ticketingDiscount: `${APIV1}/core/events/:eventId/ticketing/:ticketingId/ticketing-discount`,
        //活动嘉宾
        eventGuests: `${APIV1}/core/events/:eventId/guests`,
        eventGuest: `${APIV1}/core/events/:eventId/guests/:id`,
        guestGroups: `${APIV1}/core/events/guest-group`,
        guestGroup: `${APIV1}/core/events/guest-group/:id`,
        guestGroupEvents: `${APIV1}/core/events/guest-group/:id/events`,
        guestGroupEventExp: `${APIV1}/core/events/guest-group/export`,
        //活动日程
        eventAgendas: `${APIV1}/core/events/:eventId/agenda`,
        eventAgenda: `${APIV1}/core/events/:eventId/agenda/:id`,
        //活动海报
        eventPosters: `${APIV1}/core/events/:eventId/posters`,
        eventPoster: `${APIV1}/core/events/:eventId/posters/:id`,
        //活动视频
        eventVideos: `${APIV1}/core/events/:eventId/videos`,
        //活动二维码logo
        eventQrcodeLogo: `${APIV1}/core/events/:eventId/czqrlogo`,
        eventCiFormPreset: `${APIV1}/core/events/form/fields/preset`,
        //活动报名表单
        eventForm: `${APIV1}/core/events/:eventId/form`,
        eventFormStatistics: `${APIV1}/core/events/:eventId/form/statistics`,
        eventFormQuestionStatistics: `${APIV1}/core/events/:eventId/form/q/:questionId/statistics`,
        uniqueField: `${APIV1}/core/events/:eventId/form/unique-field`,
        eventCheckinForm: `${APIV1}/core/events/:eventId/replenish-form`,
        //活动分组
        eventGroups: `${APIV1}/core/events/groups`,
        eventGroup: `${APIV1}/core/events/groups/:id`,
        eventGroupShare: `${APIV1}/core/events/groups/share-style`,
        
        //分享样式
        shareConfig: `${APIV1}/core/events/:eventId/share`,
        eventImages: `${APIV1}/core/events/:eventId/images`,
        eventImagesBatch: `${APIV1}/core/events/:eventId/images/batch`,
        //微信分享营销
        eventWxLevelShare: `${APIV1}/core/events/:eventId/level-share`,
        eventWxLevelShareExp: `${APIV1}/core/events/:eventId/level-share/export`,
        eventWxLevelShareStatis: `${APIV1}/core/events/:eventId/level-share/statistics`,
        //邀请码
        eventCodeShares: `${APIV1}/core/events/:eventId/code-share`,
        eventCodeShare: `${APIV1}/core/events/:eventId/code-share/:id`,
        eventCodeShareImp: `${APIV1}/core/events/:eventId/code-share/import`,
        eventCodeShareExp: `${APIV1}/core/events/:eventId/code-share/export`,
        eventCodeShareTemplate: `${APIV1}/core/events/:eventId/code-share/template`,

        //邀请函打开发送统计
        invitationOpenedStats: `${APIV1}/core/events/:eventId/invitees/invitation-opened-stats`,
        confirmationOpenedStats: `${APIV1}/core/events/:eventId/attendees/confirmation-opened-stats`,
        confirmationOpened: `${APIV1}/core/events/:eventId/attendees/:attendeeId/confirmation-opened`,
        invitationOpened: `${APIV1}/core/events/:eventId/invitees/:inviteeId/invitation-opened`,

        //活动邀请函发送
        sendEventInvitation: `${APIV1}/core/events/:eventId/sendinvitation`,
        sendEventInvitationByType: `${APIV1}/core/events/:eventId/sendinvitation/:sendtype`,
        //确认函
        confirmation: `${APIV1}/core/events/:eventId/confirmation`,
        confirmationAbsent: `${APIV1}/core/events/:eventId/attendees/:attendeeId/confirmation-absent`,
        confirmationConfirm: `${APIV1}/core/events/:eventId/attendees/:attendeeId/confirmation-confirm`,
        //签到记录
        checkinlogs: `${APIV1}/core/events/:eventId/tickets/checkinlogsByPoints`,
        allCheckinlogs: `${APIV1}/core/events/tickets/checkinlogs/recent`,
        allRegisterlogs: `${APIV1}/core/events/attendees/recent`,
        checkinlogExport: `${APIV1}/core/events/:eventId/tickets/checkinlogs/export`,
        checkinInfoExtend: `${APIV1}/core/events/:eventId/tickets/checkinlogs/:logId/replenish`,
        //签到
        checkinQrcode: `${APIV1}/core/events/:eventId/tickets/checkin`,
        checkinQrcodeWithApprove: `${APIV1}/core/events/:eventId/tickets/apvnchkin`,
        
        //报名记录
        registrations: `${APIV1}/core/events/:eventId/registrations`,
        registration: `${APIV1}/core/events/:eventId/registrations/:id`,
        //签到点
        checkinpoints: `${APIV1}/core/events/:eventId/checkinpoints`,
        checkinpoint: `${APIV1}/core/events/:eventId/checkinpoints/:id`,
        checkinpointCover: `${APIV1}/core/events/:eventId/checkinpoints/:id/simple`,
        checkinpointEnable: `${APIV1}/core/events/:eventId/checkinpoints/:id/enable`,
        checkinpointDisable: `${APIV1}/core/events/:eventId/checkinpoints/:id/disable`,
        subAccountCheckinpoints: `${APIV1}/core/events/checkinpoints`,
        subUserCheckinpoints: `${APIV1}/core/events/checkinpoints/:checkinpointId/sub-users`,
        assignSubUserCheckinpoints: `${APIV1}/core/events/checkinpoints/:checkinpointId/assign-sub-users`,
        subUserAllCheckinpoints: `${APIV1}/core/events/checkinpoints/sub-users`,
        subUserAllCheckinpoint: `${APIV1}/core/events/checkinpoints/:checkinpointId/sub-users/:subUserId`,
        ticketCheckinpoints: `${APIV1}/core/events/checkinpoints/ticketing`,
        ticketCheckinpoint: `${APIV1}/core/events/checkinpoints/ticketing`,
        checkinpointTailExp: `${APIV1}/core/events/:eventId/report/tail-export`,
        checkinCancel: `${APIV1}/core/events/:eventId/tickets/cancel-checkin`,

        //人脸识别
        scanFaceSignin: `${APIV1}/core/face/sign-in`,
        faceDetect: `${APIV1}/core/face/detect`,

        //创建和查询邀请
        invitations: `${APIV1}/core/events/:eventId/invitees`,
        invitationsEmpty: `${APIV1}/core/events/:eventId/invitees/empty`,
        //勾选发送
        invitationSend: `${APIV1}/core/events/:eventId/invitees/send`,
        //全部发送
        invitationSendall: `${APIV1}/core/events/:eventId/invitees/sendall`,
        //发送未发送的
        invitationSendfirsttime: `${APIV1}/core/events/:eventId/invitees/sendfirsttime`,
        // 导入受邀人
        invitationImport: `${APIV1}/core/events/:eventId/invitees/import`,
        //勾选发送
        attendeeSmsSend: `${APIV1}/core/events/:eventId/attendees/send`,
        //全部发送
        attendeeSmsSendall: `${APIV1}/core/events/:eventId/attendees/sendall`,
        //发送未发送的
        attendeeSmsSendfirsttime: `${APIV1}/core/events/:eventId/attendees/sendfirsttime`,
        //详情
        invitation: `${APIV1}/core/events/:eventId/invitees/:inviteeId`,

        //表单查询
        extendForms: `${APIV1}/core/events/:eventId/form`,
        //查询参与人
        attendees: `${APIV1}/core/events/:eventId/attendees`,
        attendeesByids: `${APIV1}/core/events/:eventId/attendees/by-ids`,
        qaAttendees: `${APIV1}/core/events/:eventId/qa-attendees`,
        attendeesStatusStats: `${APIV1}/core/events/:eventId/attendees/status-stats`,
        attendeesDayCheckinCountStats: `${APIV1}/core/events/:eventId/attendees/by-day-checkin-count-stats`,
        attendeesTailCheckinCountStats: `${APIV1}/core/events/checkinpoints/tail-checkin-statistic`,
        attendeeExportCheckinCount: `${APIV1}/core/events/:eventId/attendees/by-day-checkin-count-stats/export`,
        attendeesIncludeCheckinLogs: `${APIV1}/core/events/:eventId/attendees/:attendeeId/tickets/checkinlogs`,
        attendee: `${APIV1}/core/events/:eventId/attendees/:attendeeId`,
        attendeeByTicketId: `${APIV1}/core/events/:eventId/attendees/tickets/:ticketId`,
        attendeeApprove: `${APIV1}/core/events/:eventId/attendees/approve`,
        attendeeDisapprove: `${APIV1}/core/events/:eventId/attendees/disapprove`,
        attendeeFormChange: `${APIV1}/core/events/:eventId/form/fill`,
        importContactAttendee: `${APIV1}/core/events/:eventId/attendees/import-from-contact-book`,
        updateContactAttendee: `${APIV1}/core/events/:eventId/attendees/update-from-contact-book`,
        attendeEexportQrcode: `${APIV1}/core/events/:eventId/attendees/qrcode-export`,
        attendeExportInfoQrcode: `${APIV1}/core//events/:eventId/attendees/info-qrcode-export`,
        attendeeExportPic: `${APIV1}/core/events/:eventId/attendees/export-pic`,
        attendeeExportFile: `${APIV1}/core/events/:eventId/attendees/export-file`,
        attendeeCollectCount: `${APIV1}/core/events/:eventId/form/q/:questionId/statistics/export`,
        importAvatar: `${APIV1}/core/events/:eventId/attendees/batch-avatar`,
        importOneAvatar: `${APIV1}/core/events/:eventId/attendees/batch-one-avatar`,
        attendeeCheckedCount: `${APIV1}/core/events/:eventId/attendees/count-checked`,
        attendeeIdList: `${APIV1}/core/events/:eventId/attendees/find-id-list`,
        attendeeExist: `${APIV1}/core/events/:eventId/attendees/exist`,
        attendeeImportTemplate: `${APIV1}/core/events/:eventId/attendees/template`,
        attendeeLevelShare: `${APIV1}/core/events/:eventId/level-share/attendees`,

        attendeeUnbindUser: `${APIV1}/core/events/:eventId/attendees/:id/unbinding-user`,

        //导入导出参与人
        attendeeImport: `${APIV1}/core/events/:eventId/attendees/import`,
        attendeeExport: `${APIV1}/core/events/:eventId/attendees/export`,
        //作废参与人
        disableAttendees: `${APIV1}/core/events/:eventId/attendees/disable`,
        disable2reject: `${APIV1}/core/events/:eventId/attendees/disable2reject`,
        //统计
        evtStatistics: `${APIV1}/core/events/:eventId/statistics`,
        evtOverAllStatistics: `${APIV1}/core/events/:eventId/statistics/overall`,

        //通过唯一标识或手机验证查询门票
        tickets: `${APIV1}/core/events/:eventId/tickets`,
        //找回凭证
        gpbyattds: `${APIV1}/core/events/:eventId/tickets/gpbyattd`,

        //打印
        printing: `${APIV1}/core/events/badges/printing`,
        badgeLayouts: `${APIV1}/core/events/:eventId/badge-layouts`,
        badgeLayout: `${APIV1}/core/events/:eventId/badge-layouts/:id`,
        badgeLabel: `${APIV1}/core/events/badges/label`,
        badgeExp: `${APIV1}/core/events/:eventId/badges/export`,
        badgeView: `${APIV1}/core/events/badges/view`,
        badgeDownload: `${APIV1}/core/events/badges/download`,

        //批量发送短信
        sendEmailMsg: `${APIV1}/core/events/:eventId/send-msg`,
        sendHistoryMsg: `${APIV1}/core/events/send-msg-history`,
        sendCost: `${APIV1}/core/events/send-cost`,

        //微站
        microsites: `${APIV1}/core/events/:eventId/microsite`,
        microsite: `${APIV1}/core/events/:eventId/microsite/:id`,
        micrositeEnabled: `${APIV1}/core/events/:eventId/microsite/:id/enabled`,
        micrositeCover: `${APIV1}/core/events/:eventId/microsite/cover`,
        micrositeConfig: `${APIV1}/core/events/:eventId/microsite-config`,

        //评论
        eventComments: `${APIV1}/core/events/:eventId/comments`,
        eventComment: `${APIV1}/core/events/:eventId/comments/:id`,
        eventCommentPages: `${APIV1}/core/events/:eventId/comments/page`,


        //独立问卷
        surveyPreset: `${APIV1}/core/survey/preset`,
        surveys: `${APIV1}/core/survey`,
        adminSurveys: `${APIV1}/core/admin/survey`,
        survey: `${APIV1}/core/survey/:id`,
        surveyRecover: `${APIV1}/core/survey/:id/recover`,
        surveyCopy: `${APIV1}/core/survey/:id/copy`,
        surveyAnswers: `${APIV1}/core/survey/:id/answer`,
        surveyAnswer: `${APIV1}/core/survey/:id/answer/:answerId`,
        surveyStatistic: `${APIV1}/core/survey/:id/statistic`,
        surveyContentStatistic: `${APIV1}/core/survey/:id/statistic/content`,
        surveyExport: `${APIV1}/core/survey/:id/export`,
        surveyEmptyAnswer: `${APIV1}/core/survey/:id/title/:titleId/empty-answer`,


        //投票
        votes: `${APIV1}/core/vote`,
        adminVotes: `${APIV1}/core/admin/vote`,
        vote: `${APIV1}/core/vote/:id`,
        voteTitle: `${APIV1}/core/vote/:id/title/:titleId`,
        votesAnswers: `${APIV1}/core/vote/:id/answer`,
        votesCaptcha: `${APIV1}/core/vote/:id/captcha`,
        votesAnswerName: `${APIV1}/core/vote/:id/check-answer-name`,
        votesStatistic: `${APIV1}/core/vote/:id/statistic`,
        votesStatisticId: `${APIV1}/core/vote/:id/title/:titleId/statistic`,
        votesExport: `${APIV1}/core/vote/:id/export`,
        votesCopy: `${APIV1}/core/vote/:id/copy`,
        votesEmptyAnswer: `${APIV1}/core/vote/:id/title/:titleId/empty-answer`,
        votesEmpty: `${APIV1}/core/vote/:id/empty`,

        //订单计算
        calculatePrice: `${APIV1}/core/orders/calculate-price`,
        orderUpdateDesc: `${APIV1}/core/orders/:orderId/update-desc`,
        //退款
        orderRefund: `${APIV1}/core/orders/:orderId/refund`,
        orderRefunds: `${APIV1}/core/orders/:orderId/refunds`,
        orderPreRefund: `${APIV1}/core/orders/:orderId/pre-refund`,
        orders: `${APIV1}/core/orders`,
        //红包订单列表
        luckMoneyOrders: `${APIV1}/core/orders/luckymoney`,
        //打赏订单列表
        rewardOrders: `${APIV1}/core/orders/reward`,
        //会销订单列表
        marketdOrders: `${APIV1}/core/orders/market`,
        //购票订单列表
        ticketOrders: `${APIV1}/core/orders/ticket`,
        ticketOrdersCreate: `${APIV1}/core/orders/create-for-ticket`,
        //报名并签到
        ticketOrdersCreateAndCheckin: `${APIV1}/core/orders/create-for-ticket-and-checkin`,
        //增值订单列表
        vasOrders: `${APIV1}/core/orders/vas`,
        vasOrdersCreate: `${APIV1}/core/orders/create-for-vas`,
        //订单详情
        order: `${APIV1}/core/orders/:orderId`,
        //关闭订单
        orderClose: `${APIV1}/core/orders/:orderId/close`,
        //发货订单
        orderDeliver: `${APIV1}/core/orders/:orderId/deliver`,
        //调起支付
        payinfo: `${APIV1}/core/orders/:_orderId/payinfo`,
        //完成转账
        completedTransfer: `${APIV1}/core/orders/:orderId/completed-transfer`,
        //
        rechargeOrder: `${APIV1}/core/orders/create-for-recharge`,
        orderExport: `${APIV1}/core/orders/export`,
        //支付渠道配置
        userMerchants: `${APIV1}/core/pay/user/merchants`,
        saveMechantUser:`${APIV1}/core/pay/user/addUser/:userId`,
        saveUserPaySwitch:`${APIV1}/core/pay/user/setPaySwitch/:id/:paySwitch`,
        saveUserWechatMerchant:`${APIV1}/core/pay/user/addWechat`,
        updateUserWechatMerchant:`${APIV1}/core/pay/user/updateWechat`,
        saveUserAlipayMerchant:`${APIV1}/core/pay/user/addAliPay`,
        updateUserAlipayMerchant:`${APIV1}/core/pay/user/updateAlipay`,
        wechatMerchants: `${APIV1}/core/pay/wechat/merchants`,
        wechatMerchant: `${APIV1}/core/pay/wechat/merchants/:id`,
        wechatCusPay: `${APIV1}/core/events/:eventId/header/custom-pay`,
        alipayMerchants: `${APIV1}/core/pay/alipay/merchants`,
        alipayMerchant: `${APIV1}/core/pay/alipay/merchants/:id`,

        //互动配置
        experiences: `${APIV1}/core/member/experience`,
        experience: `${APIV1}/core/member/experience/:id`,


        //获取微信签名
        signature: `${APIV1}/core/others/wxmp/jsapi-signature`,
        thirdAuth: `${APIV1}/core/thirdAuth/state`,
        authcodereport: `${APIV1}/core/thirdAuth/authCodeReport`,
        switchOper: `${APIV1}/core/thirdAuth/switchOper`,
        msgTemplateCheck: `${APIV1}/core/thirdAuth/msgTemplateCheck`,
        

        //pc版本管理
        pcversions: `${APIV1}/pc-versions`,
        pcversion: `${APIV1}/pc-versions/:id`,
        // 客服配置
        customers: `${APIV1}/customers`,
        customer: `${APIV1}/customers/:id`,
        //ios
        ioss: `${APIV1}/ioss`,
        ios: `${APIV1}/ioss/:id`,
        //androids
        androidClients: `${APIV1}/androids`,
        androidClient: `${APIV1}/androids/:id`,






    },
    ws: `${currentDominWs}/ws/cm-websocket`,
}



// WEBPACK FOOTER //
// ./src/utils/config.js